import { render, staticRenderFns } from "./MyCustomerTable.vue?vue&type=template&id=2a99d422&scoped=true"
import script from "./MyCustomerTable.vue?vue&type=script&lang=js"
export * from "./MyCustomerTable.vue?vue&type=script&lang=js"
import style0 from "./MyCustomerTable.vue?vue&type=style&index=0&id=2a99d422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99d422",
  null
  
)

export default component.exports